export default __webpack_public_path__ + "static/media/white-next-arrow.28609a17.svg";